import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Paper, Dialog, DialogActions, DialogContent, DialogTitle, Grid} from '@material-ui/core'
import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Container, Box, IconButton, Tabs, Tab} from '@material-ui/core'
import {Button, FormControl, Checkbox, TextField, InputLabel, MenuItem, Select } from '@material-ui/core';
import {MoreVert} from '@material-ui/icons';

import {EditDispatcherPermissionsDialog} from './EditDispatcherPermissionDialog'

import { TabPanel } from '../../../components/TabPanel';

import {PERMISSION_DEFAULT} from '../../../FleetConsole/api/ServerApi'
import { checkPassword, isInteger, isNumber } from '../../../api/validators';

class EditDispatcherDialog_ extends React.Component{

    constructor(props){
        super(props)


        var dispatcher = JSON.parse(JSON.stringify(this.props.dispatcher));
        //const dispatcher = {...this.props.dispatcher} 
        //if(dispatcher.DispatcherData) dispatcher.DispatcherData = [...dispatcher.DispatcherData]
        //if(dispatcher.AllowedNetworks) dispatcher.AllowedNetworks = [...dispatcher.AllowedNetworks] 

        this.state = {
            dispatcher: dispatcher ? dispatcher : {
                DispatcherData: {
                    AllowAdministrativeMode: 0,
                    AllowManageServer: 1,
                    ID: "EREREREREREREREREREREQ==",
                    Login: "Administrator",
                    Name: "Administrator",
                    Permissions: -1,
                    Priority: 0,
                    RadioID: 0,
                    SingleLogin: 0
                },
                Password: '',
                AllowedNetworks: []
            },
            errors:{
                Login: false, 
                Name: false,
                Password: false,
                RadioID: false
            },
            permissionsDialogOpen: false,
            changed: false,
            tab: 0,
            permissionsType: dispatcher.DispatcherData.ID && dispatcher.DispatcherData.Permissions>=0 ? 0 : -1
        }

        this.handleTabChange = this.handleTabChange.bind(this)
        this.handleInput = this.handleInput.bind(this)
        this.handleAction = this.handleAction.bind(this)
        this.handleAllowInput = this.handleAllowInput.bind(this)
    }   

    handleSave(){
        const {t} = this.props
        if(this.checkForm()){
            this.props.onAction({type: 'DISPATCHER_EDITOR_SAVE', dispatcher: this.state.dispatcher})
        }else{
            this.props.onAction({type:'ALERT_DIALOG', message: this.props.t('CheckFormForErrors')})
        }
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'DISPATCHER_EDITOR_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'DISPATCHER_EDITOR_CLOSE'})
        }
    }

    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        const dispatcher = this.state.dispatcher

        if(event.target.name==='Password'){
            dispatcher[event.target.name] = val
        }else{
            dispatcher.DispatcherData[event.target.name] = val
        }

        let err = this.validate(event.target.name, val)
        const errors = {errors: {...this.state.errors, [event.target.name]: err}}

        this.setState({dispatcher: dispatcher, ...changed,  ...errors})
    }

    handlePermissionsTypeChange(event){
        const dispatcher = {...this.state.dispatcher}
        if(event.target.value===0 && this.state.dispatcher.DispatcherData.Permissions===-1){
            dispatcher.DispatcherData.Permissions = PERMISSION_DEFAULT
        }else if(event.target.value===-1){
            dispatcher.DispatcherData.Permissions = -1
        }
        console.error(event.target.value)
        console.error(dispatcher)
        this.setState({permissionsType: event.target.value, dispatcher: dispatcher})
    }

    handleAction(action){
        switch(action.type){
            case 'DISPATCHER_PERMISSIONS_EDITOR_OPEN':
                this.setState({permissionsDialogOpen: true})
                break;

            case 'DISPATCHER_PERMISSIONS_EDITOR_CLOSE':
                this.setState({permissionsDialogOpen: false})
                break;

            case 'DISPATCHER_PERMISSIONS_EDITOR_SAVE':
                let changed = !this.state.changed ? {changed: true} : {}

                this.setState({permissionsDialogOpen: false})

                let permissions_1 = action.permissions % 4294967296
                let permissions_2 = Math.trunc(action.permissions/4294967296)

                //console.log('DISPATCHER_PERMISSIONS_EDITOR_SAVE')
                //console.log(action.permissions)
                //console.log('permissions_1')
                //console.log(permissions_1)
                //console.log('permissions_2')
                //console.log(permissions_2)


                const dispatcher = {...this.state.dispatcher}
                dispatcher.DispatcherData.Permissions = permissions_1 //action.permissions
                dispatcher.DispatcherData.Permissions2 = permissions_2
                this.setState({dispatcher: dispatcher, ...changed})
                break

            default:
                this.props.onAction(action)
        }
    }

    validate(name, value){
        const {t} = this.props
        let error = false

        switch(name){
            case 'Login': 
                if(!value){
                    error = t('LoginIsEmpty')
                }
                break

            case 'Name':
                if(!value){
                    error = t('NameIsEmpty')
                }
                break

            //case 'LocationPeriod':
            case 'RadioID':
                if(value && !isNumber(value)){
                    error = t('IsNotNumber')
                }else if(value && !isInteger(value)){
                    error = t('IsNotInteger')
                }
                break
                
            case 'Password':
                if(!checkPassword(value, this.props.passwordPolicy)){
                    error = t('BadPassword')
                }
                break

            default:
                console.log('Empty validator '+name)
        }

        return error
    }

    checkForm(){
        console.log('checkform')
        console.log(this.state.dispatcher)
        let check = true
        let errors = {...this.state.errors}
        for(var i in errors){
            let v = null
            let error = false
            if(i==='Password'){
                v = this.state.dispatcher[i]
            }else{
                v = this.state.dispatcher.DispatcherData[i]
            }
            error = this.validate(i, v)
            errors[i] = error
            if(error) {
                console.error({field: i, value: v, error: error})
                check = false
            }
        }
        this.setState({errors: errors})
        return check
    }

    handleAllowInput(event, ID, name){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        const dispatcher = {...this.state.dispatcher}


        let index = dispatcher.AllowedNetworks.findIndex((item)=>{
            return item.ID===ID
        })

        //console.log({index: index, name: name, val:val} )

        if(index>=0){
            switch(name){
                case 'enabled':
                    if(!val){
                        dispatcher.AllowedNetworks.splice(index, 1)
                    }
                    break
                case 'allGroups':
                    dispatcher.AllowedNetworks[index].AllGroups = val
                    break
                default:
            }
        }else{
            let allow = {ID: ID, AllGroups: false}
            switch(name){
                case 'enabled':
                    break
                case 'allGroups':
                    allow.AllGroups = val
                    break
                default:
            }

            dispatcher.AllowedNetworks.push(allow)
        }

        this.setState({dispatcher: dispatcher, ...changed})
    }

    getNetworkAllows(networkID){
        //console.log(this.state.dispatcher)
        let index = this.state.dispatcher.AllowedNetworks.findIndex((item)=>{
            return item.ID===networkID
        })

        let allow
        if(index>=0){
            allow = {enabled: true, allGroups: this.state.dispatcher.AllowedNetworks[index].AllGroups, ID: networkID}
        }else{
            allow = {enabled: false, allGroups: false, ID: networkID}
        }
        //console.log(allow)
        return allow
    }

    checkLicense(licenseName){
        return this.props.onAction({type: 'LICENSE_CHECK', licenseName: licenseName})
    }

    generalTab(styles){

        const {t} = this.props

        const margin = {margin:'16px 0 8px 0'}

        const dispatcherData = this.state.dispatcher.DispatcherData

        let dispatcherPermissionsDialog = '';
        if(this.state.permissionsDialogOpen){

            const d = this.state.dispatcher.DispatcherData
            //const permissions = dispatcherData.Permissions

            const permissions = d.Permissions + (d.Permissions2 ? d.Permissions2 * 4294967296 : 0)

            //console.log('EditDispatcherPermissionsDialog permissions')
            //console.log(d)
            //console.log(permissions)

            const indoorTrackingEnabled = this.checkLicense('IndoorTracking')
            const monitoringEnabled = this.checkLicense('Monitoring')

            //console.log('indoorTrackingEnabled = '+ (indoorTrackingEnabled?'true':'false')) 

            dispatcherPermissionsDialog = (
                <EditDispatcherPermissionsDialog
                    open={this.state.permissionsDialogOpen}
                    monitoringEnabled={monitoringEnabled}
                    indoorTrackingEnabled={indoorTrackingEnabled}
                    permissions={permissions}
                    onAction={this.handleAction}
                    />
            )
        }

        return(
            <>
            <Box textAlign="center">
                <TextField name="Login"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.Login?this.state.errors.Login:t('Login')}
                    autoComplete="new-password"
                    error={this.state.errors.Login!==false}
                    value={this.state.dispatcher.DispatcherData.Login}
                    onChange={this.handleInput}
                />

            </Box>
            <Box textAlign="center">
                <TextField name="Name"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.Name?this.state.errors.Name:t('Name')}
                    autoComplete="new-password"
                    error={this.state.errors.Name!==false}
                    value={this.state.dispatcher.DispatcherData.Name}
                    onChange={this.handleInput}
                />
            </Box>
            <Box textAlign="center">
                <TextField type="password" name="Password" margin="normal"
                    style={{width: '100%'}}
                    autoComplete="new-password"
                    label={this.state.errors.Password?this.state.errors.Password:t('Password')}
                    error={this.state.errors.Password!==false}
                    value={this.state.dispatcher.Password}
                    onChange={this.handleInput}
                />
            </Box>
            

            <Box textAlign="left">
            <FormControl style={{...margin, width: '100%'}}>
                <InputLabel htmlFor="Priority">{t('Priority')}</InputLabel>
                <Select
                    value={this.state.dispatcher.DispatcherData.Priority}
                    onChange={this.handleInput}
                    inputProps={{
                        name: 'Priority',
                        id: 'Priority',
                    }}
                    >
                    <MenuItem key="14" value={14}>+14</MenuItem>
                    <MenuItem key="13" value={13}>+13</MenuItem>
                    <MenuItem key="12" value={12}>+12</MenuItem>
                    <MenuItem key="11" value={11}>+11</MenuItem>
                    <MenuItem key="10" value={10}>+10</MenuItem>
                    <MenuItem key="9" value={9}>+9</MenuItem>
                    <MenuItem key="8" value={8}>+8</MenuItem>
                    <MenuItem key="7" value={7}>+7</MenuItem>
                    <MenuItem key="6" value={6}>+6</MenuItem>
                    <MenuItem key="5" value={5}>+5</MenuItem>
                    <MenuItem key="4" value={4}>+4</MenuItem>
                    <MenuItem key="3" value={3}>+3</MenuItem>
                    <MenuItem key="2" value={2}>+2</MenuItem>
                    <MenuItem key="1" value={1}>+1</MenuItem>
                    <MenuItem key="0" value={0}>{t('Default')}</MenuItem>
                    <MenuItem key="-1" value={-1}>-1</MenuItem>
                </Select>
            </FormControl>
            </Box>

            <Box textAlign="center">
                <Grid container>
                    <Grid item xs={11} align="left">

                        <FormControl style={{...margin, width: '100%'}}>
                            <InputLabel htmlFor="permissionsType">{t('Permissions')}</InputLabel>
                            <Select 
                                value={this.state.permissionsType}
                                onChange={this.handlePermissionsTypeChange.bind(this)}
                                
                                inputProps={{
                                    name: 'permissionsType',
                                    id: 'permissionsType',
                                }}
                                >
                                <MenuItem key="-1" value={-1}>{t('InheritedFromNetwork')}</MenuItem>
                                <MenuItem key="0" value={0}>{t('Custom')}</MenuItem>
                            </Select>
                        </FormControl>

                    </Grid>
                    <Grid item xs={1} style={{verticalAlign:'bottom', paddingTop:33}}>
                        <IconButton disabled={this.state.permissionsType===-1} 
                            size="small" color="inherit" aria-label="more permissions" component="span"
                            style={{width2: 16, height2: 16}}
                            onClick={()=>{this.handleAction({type: 'DISPATCHER_PERMISSIONS_EDITOR_OPEN'})}}>
                            <MoreVert />
                        </IconButton>
                    </Grid>
                </Grid>

                {dispatcherPermissionsDialog}
            
            </Box>

            <Box textAlign="left" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            disabled={this.state.dispatcher.DispatcherData.ID==="EREREREREREREREREREREQ=="}
                            checked={Boolean(this.state.dispatcher.DispatcherData.AllowManageServer)}
                            onChange={this.handleInput}
                            name="AllowManageServer"
                            />
                            {t('AllowConnectToServerManager')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="left" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={Boolean(this.state.dispatcher.DispatcherData.AllowAdministrativeMode)}
                            onChange={this.handleInput}
                            name="AllowAdministrativeMode"
                            />
                            {t('AllowAdministrativeMode')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="left" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={Boolean(this.state.dispatcher.DispatcherData.AllowSystemMonitoring)}
                            onChange={this.handleInput}
                            name="AllowSystemMonitoring"
                            />
                            {t('AllowSystemMonitoring')}
                    </label>
                </FormControl>
            </Box>
        
            <Box textAlign="left" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={Boolean(this.state.dispatcher.DispatcherData.SingleLogin)}
                            onChange={this.handleInput}
                            name="SingleLogin"
                            />
                            {t('RestrictLoginFromOtherDevices')}
                    </label>
                </FormControl>
            </Box>
            
            <Box textAlign="center" style={{...margin, width: '100%'}}>
                <label>
                {t('AllowedNetworks')}
                </label>


                <Paper style={{maxHeight: 250, overflow: 'auto'}}>
                <Table size="small">

                    <TableHead>
                        <TableRow>
                            <TableCell style={{...styles.head}}>{t('')}</TableCell>
                            <TableCell style={styles.head}>{t('Network')}</TableCell>
                            <TableCell style={{...styles.head}}>{t('AllGroups')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.props.networks.map((network)=>{
                            let allows = this.getNetworkAllows(network.ID)
                            return (
                                <TableRow key={network.ID} >
                                   <TableCell style={{width:50}}>
                                        <Checkbox color="primary" 
                                            checked={allows.enabled}
                                            onChange={(e)=>{let ID=network.ID; this.handleAllowInput(e, ID, 'enabled')}}
                                            name={"enabled_"+network.ID}
                                            />
                                    </TableCell>
                                    <TableCell>{network.Name}</TableCell>
                                    <TableCell style={{width:50}}>
                                        <Checkbox color="primary" 
                                            disabled={!allows.enabled}
                                            checked={allows.allGroups}
                                            onChange={(e)=>{let ID=network.ID; this.handleAllowInput(e, ID, 'allGroups')}}
                                            name={"allGroups_"+network.ID}
                                            />
                                    </TableCell>
                                </TableRow>
                            )

                        })
                    }
                    </TableBody>

                </Table>
                </Paper>

            </Box>  

            </>
        )
    }

    dmrTab(styles){
        const {t} = this.props
        return(
        <>
            <Box textAlign="center">
                <TextField name="RadioID"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.RadioID?this.state.errors.RadioID:t('VirtualRadioID')}
                    autoComplete="new-password"
                    error={this.state.errors.RadioID!==false}
                    value={this.state.dispatcher.DispatcherData.RadioID}
                    onChange={this.handleInput}
                />
            </Box>
        </>
        )
    }

    handleTabChange(event, newValue){
        this.setState({tab: newValue})
    }

    render(){
        const {t} = this.props

        //console.log('this.state.dispatcher');
        //console.log(this.state.dispatcher);

        const title = this.props.action==='add'?t('NewDispatcher'):t('EditDispatcher')
        
        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            },
            tab: {
                minHeight: 300
            }
        }

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:400}}>


            <Tabs  value={this.state.tab} 
                variant="scrollable"
                scrollButtons="auto"
                onChange={this.handleTabChange} aria-label="simple tabs example"
                indicatorColor="primary">
                <Tab wrapped style={{minWidth:80}} label={t("General")} id="tab-0" aria-controls="tabpanel-0" />
                <Tab wrapped style={{minWidth:80}} label={t("DMR")} id="tab-1" aria-controls="tabpanel-1" />
            </Tabs>
  

            <TabPanel value={this.state.tab} index={0} style={styles.tab}>
                {this.generalTab(styles)}
            </TabPanel>

            <TabPanel value={this.state.tab} index={1} style={styles.tab}>
                {this.dmrTab(styles)}
            </TabPanel>


        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave.bind(this)} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const EditDispatcherDialog = withTranslation()(EditDispatcherDialog_);